import React from "react";
import { Select } from "antd";
import { Text, LinkButton } from "@networkraildigitalfactory/components";
import styles from "./Filters.module.css";
import "./AntdFilters.css";

const Filters = (props) => {
  const { Option } = Select;
  const { clearFilters, onStatusChange, onYearChange, yearValue, statusValue } = props;

  const sevenYears = [];
  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;
  sevenYears.push(nextYear);
  for (let i = 0; i < 14; i += 1) {
    const yearToPush = currentYear - i;
    if (yearToPush >= 2020) {
      sevenYears.push(yearToPush);
    }
  }

  return (
    <div className={styles.filter_wrapper}>
      <LinkButton
        onClick={clearFilters}
        text=""
        style={{
          color: "#727272",
          fontStyle: "italic",
        }}
      >
        clear all filters
      </LinkButton>
      <div className={styles.filter_text}>
        <Text
          wrapper="h4"
          type="body"
          color="#000000"
          style={{ marginLeft: "10px", marginRight: "10px", marginTop: "10px" }}
        >
          year due
        </Text>
        <Select
          placeholder="All years"
          style={{ width: 150 }}
          value={yearValue}
          allowClear
          onChange={onYearChange}
          getPopupContainer={(triggerNode) => triggerNode}
        >
          <Option disabled hidden value="" style={{ color: "#727272" }}>
            All years
          </Option>
          {sevenYears.map((year) => {
            return (
              <Option key={year} value={year}>
                {year}
              </Option>
            );
          })}
        </Select>
      </div>
      <div className={styles.filter_text}>
        <Text
          wrapper="h4"
          type="body"
          color="#000000"
          style={{ marginLeft: "10px", marginRight: "10px", marginTop: "10px" }}
        >
          status
        </Text>
        <Select
          placeholder="All statuses"
          style={{ width: 150 }}
          allowClear
          onChange={onStatusChange}
          value={statusValue}
          getPopupContainer={(triggerNode) => triggerNode}
        >
          <Option disabled hidden value="" style={{ color: "#727272" }}>
            All statuses
          </Option>
          {!props.isLineManagerView && <Option value="draft">Draft</Option>}
          <Option value="pending approval">Pending approval</Option>
          <Option value="review required">Review required</Option>
          <Option value="approved">Approved</Option>
          <Option value="employee complete">Employee complete</Option>
          <Option value="completed">Completed</Option>
          <Option value="cancelled">Cancelled</Option>
          <Option value="closed">Closed</Option>
        </Select>
      </div>
    </div>
  );
};

export default Filters;
